import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { Form } from '~/components';
import { ButtonProps } from '~/components/Button';
import FormDrawer from '~/components/FormDrawer';
import { useEditSalesLead } from '~/controllers/sales';

import { LeadShowConverted } from '~/pages/agent/components/agent/leadForm/LeadShowConverted';
import { LeadShowOpen } from '~/pages/agent/components/agent/leadForm/LeadShowOpen';
import { LeadShowTerminated } from '~/pages/agent/components/agent/leadForm/LeadShowTerminated';
import { AgentLead } from '~/types/AgentLead';
import buildNamePath from '~/utils/buildNamePath';

import { isSales } from '~/utils/getDecodedJwt';

import LeadForm from './LeadForm';

interface Props {
  open: boolean;
  onClose: () => void;
  initialValues?: AgentLead;
  setInitialValues?: any;
  refetch?: any;
}

const LeadEdit: React.FC<Props> = (props) => {
  const { initialValues, setInitialValues, open, onClose, refetch } = props;
  const { t } = useTranslation('agent');
  const editLead = useEditSalesLead();
  const [form] = Form.useForm<any>();
  const onEdit = async (newValues: any, withCloseDrawer = true) => {
    try {
      await editLead.mutateAsync(newValues);
      // if (isSales())
      //   await editLead.mutateAsync({
      //     leadId: newLead.leadId,
      //     agentId: newValues.assignee?.id ?? '',
      //     ...newLead,
      //   });
      refetch();
      if (withCloseDrawer) onClose();
      form.resetFields();
      // await queryClient.invalidateQueries('leads');
    } catch (e) {
      return console.log('error', e);
    }
  };

  const createLeadButton = [
    {
      id: 'createLeadButton',
      title: t('Save'),
      type: 'default',
      htmlType: 'submit',
      loading: editLead.isLoading || editLead.isLoading,
      danger: true,
      form: formName,
    },
  ] as ButtonProps[];

  if (initialValues?.statusKey === 'NEW' || initialValues?.statusKey === 'CONTACTED')
    return <LeadShowOpen open={open} initialValues={initialValues} onClose={onClose} />;
  if (initialValues?.statusKey === 'TERMINATED')
    return <LeadShowTerminated open={open} initialValues={initialValues} onClose={onClose} />;
  if (initialValues?.statusKey === 'CONVERTED')
    return <LeadShowConverted open={open} initialValues={initialValues} onClose={onClose} />;

  return (
    <FormDrawer
      customButtonsProps={createLeadButton}
      id="leadEdit"
      open={open}
      closable
      withContinueButton
      onClose={() => {
        form.resetFields();
        setInitialValues({});
        onClose();
      }}
      afterOpenChange={(isOpen) => {
        if (!isOpen) {
          form.resetFields();
        }
      }}
      title={t('Edit Lead')}
      formName={formName}
      withCustomButtons
    >
      {!!Object.keys(initialValues || {})?.length && (
        <LeadForm
          form={form}
          n={buildNamePath([])}
          onFinish={onEdit}
          initialValues={initialValues}
          edit
          formName={formName}
        />
      )}
    </FormDrawer>
  );
};

export default LeadEdit;

const formName = 'editLeadForm';
